/* src/app/components/select-cbm-stars/select-cbm-stars.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.selector-container {
  margin-block: 5px;
  overflow: visible;
  position: relative;
  font-size: 18px;
  margin: 0px 3px;
  font-family: "Helvetica Neue", serif;
  width: 285px;
}
.select-custom {
  width: 100%;
  height: 50px;
  color: #333333;
  border: 1px solid #7376BC;
  padding: 5px 30px 5px 15px;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.select-custom:hover,
.focused {
  border: 1px solid #00b7bd;
}
.selected-item {
  color: #333333;
  cursor: default;
}
.selected-items {
  display: flex;
  flex-direction: row;
  height: 31px;
  padding-right: 30px;
  flex-wrap: wrap;
  overflow: hidden;
  cursor: default;
}
.selected-items div img {
  display: inline-block;
  margin-left: 7px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.selected-items div {
  display: flex;
  align-items: center;
  font-family: "Gotham-Book", serif;
  font-size: 18px;
  color: #FFF;
  background-color: #5F96BA;
  height: 31px;
  border-radius: 4px;
  padding: 2px 15px;
  margin-right: 2px;
  white-space: nowrap;
  text-wrap: none;
  cursor: default;
}
.select-count {
  color: #9A9B9C;
  position: absolute;
  right: 35px;
}
.placeholder-text {
  color: #9A9B9C;
}
.select-custom-options {
  position: absolute;
  top: 51px;
  left: 0px;
  display: inline-block;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
  max-height: 235px;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 10;
}
.select-custom-options::-webkit-scrollbar {
  background-color: #FFF;
  width: 5px;
}
.select-custom-options::-webkit-scrollbar-thumb {
  background-color: #9A9B9C;
  border-radius: 5px;
}
.select-custom-options .disabled {
  color: #9A9B9C;
}
.select-custom-options .disabled:hover {
  background-color: #FFF;
}
.select-custom-options .selected {
  background-color: #00b7bd;
  color: #FFF;
}
.select-custom-options div {
  height: 50px;
  padding: 10px;
  background-color: #FFF;
  z-index: 10;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-family: "Helvetica Neue", serif;
  font-size: 18px;
  color: #333333;
}
.select-custom-options div:hover {
  background-color: #CCF1F2;
}
.select-custom-options div input[type=checkbox] {
  display: inline-block;
  width: 20px;
  padding: 0;
  margin: 0 5px 0 0;
}
.select-custom-options div div {
  background-color: transparent;
  padding: 0px;
}
.arrow,
.arrow-down,
.arrow-up,
.arrow-left,
.arrow-right {
  border: solid #9A9B9C;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  position: absolute;
  top: 40%;
  right: 15px;
  font-size: 30px;
}
.arrow-focused {
  border-color: #00b7bd;
}
.arrow-right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}
.arrow-left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}
.arrow-up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}
.arrow-down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.star-rating {
  width: 25px;
  height: 22px;
}
@media screen and (max-width: 1024px) {
  .selector-container {
    width: 100%;
  }
}
/*# sourceMappingURL=select-cbm-stars.component.css.map */
